export default "__VITE_ASSET___FbtX1qX__"